import { Link } from "react-router-dom";
import React from "react";
import "../styles/UIDesign.css";

const UIDesign = () => {
  return (
    <main className="ui-page">

      <section className="ui-hero">
        <div className="ui-text">
          <span>DESIGN SERVICE 02</span>
          <h1><span>UI</span><i aria-hidden="true">/</i><span>UX</span><small>design for people and products</small></h1>
          <p>
            Create meaningful digital experiences through thoughtful interfaces, intuitive user journeys and flexible visual systems. Every decision has a purpose: make the product easier to understand and more rewarding to use.
          </p>
        </div>

        <div className="ui-card">
          <h3>01</h3>
          <h2>Think · Design · Experience</h2>
          <p>We bring user needs and business goals together, then turn the strongest ideas into usable product experiences.</p>
          <ul><li>Clearer journeys</li><li>Consistent interface patterns</li><li>Accessible by design</li></ul>
        </div>
      </section>

      <section className="ui-services">
        <h2>Design That Connects</h2>

        <div className="ui-grid">
          <article><b>01 · Research</b><p>Understand your audience, their context and the moments where your product can help.</p></article>
          <article><b>02 · Structure</b><p>Map information, user flows and wireframes so every screen has a clear job.</p></article>
          <article><b>03 · Interface</b><p>Build a visual language and reusable components that make the product feel coherent.</p></article>
          <article><b>04 · Prototype</b><p>Test realistic interactions early, learn from feedback and refine the experience.</p></article>
        </div>
      </section>

      <section className="ui-cta">
        <h2>Design Experiences People Remember</h2>
        <Link to="/contact">Start a Design Project →</Link>
      </section>

      <section className="ui-outcomes"><span>DESIGNED TO WORK IN THE REAL WORLD</span><p>Responsive layouts · Design systems · Interactive prototypes · Accessibility considerations</p></section>
    </main>
  );
};

export default UIDesign;